import { GET_WATCH_LIST, SET_WATCH_LIST, SET_WATCHED, WATCH_GAME } from './constants';

export const getWatchList = () => ({ type: GET_WATCH_LIST });
export const setWatchList = (games) => ({ type: SET_WATCH_LIST, payload: { games } });
/** Starts watching game `gameId`: loads it and keeps it up to date until you leave the page. */
export const watchGame = (gameId) => ({ type: WATCH_GAME, payload: { gameId } });
export const setWatched = (game, log) => ({ type: SET_WATCHED, payload: { game, log } });
